// CDN 专用路径映射：原始域名 => cdn 路径，命中即替换，后续新增在此添加即可
const CDN_PATH_MAP = [{ from: 'pbs.twimg.com/', to: 'pbs-media/' }];

// 处理图片链接到cdn访问
export function dealwithImgUrl(urls: string) {
  const url = (urls || '').split('|').filter(Boolean)[0];
  if (!url || url.includes('.myqcloud.com/')) {
    return url;
  }
  // Already on an ogdb CDN domain — no need to re-wrap
  if (
    url.includes('ogdb-cdn.intlgame.cn') ||
    url.includes('ogdb-file.intlgame.cn')
  ) {
    return url;
  }

  const noProtocolUrl = url.replace(/^(https?:)?\/\//, '');
  for (const { from, to } of CDN_PATH_MAP) {
    if (noProtocolUrl.startsWith(from)) {
      return `https://ogdb-file.intlgame.cn/${to}${noProtocolUrl.slice(
        from.length,
      )}`;
    }
  }
  return `https://ogdb-file.intlgame.cn/${noProtocolUrl}`;
}

export const dealwithBiLiBiLiImage = (url: string) => {
  // ogdb-file.intlgame.cn/

  const urlPatterns = [
    /i[\d]+.hdslb.com/,
    /instagram.[\w-]+.fna.fbcdn.net/,
    /scontent-[\w-]+.xx.fbcdn.net/,
    /scontent-[\w-]+.cdninstagram.com/,
    /[\w]+.ggpht.com/,
    /[\w]+.twimg.com/,
  ];

  for (const pattern of urlPatterns) {
    if (pattern.test(url)) {
      return dealwithImgUrl(url);
    }
  }

  return url;
};

export function getMatchUrl(url: string) {
  try {
    if (url.startsWith('http:') && location.protocol === 'https:') {
      const httpsUrl = url.replace(/^http:/, 'https:');
      return httpsUrl;
    }
  } catch {}
  return url;
}
